<ng-container *ngIf="items && items.length > 0">

  <label *ngIf="label" for="{{ parentId }}" class="floating-label">{{ label | translate }} </label>

  <div class="dropdown" [id]="parentId">
    <button
            #dopdownBtn
            id="dropdown_{{parentId}}"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            [disabled]="disabled"
            class="btn custom-dropdown d-flex"
            [class.w-100]="isFullWidth"
            [class.error]="showError">
      <span class="overflow-elipsis flex-grow-1">{{selectedOption?.label | translate}}</span>
      <span class="icon i-dropdown-arrow" [class.disabled-icon]="disabled" id="selectCoverage_{{parentId}}"></span>
    </button>

    <ul class="dropdown-menu p-0" [class.w-100]="isFullWidth" [attr.aria-labelledby]="'dropdown_' + parentId">
      <li *ngFor="let item of items; trackBy: trackItemBy">
        <button type="button"
                class="dropdown-item text-wrap d-flex justify-content-between align-items-start"
                (click)="onSelectOption(item)"
                [class.active]="item.value === selectedOption?.value"
                [class.wide]="coverage"
                [disabled]="disabled"
                [class.clickable]="!disabled"
                id="coverage_{{parentId}}_{{item.coverageMonths}}_Months">

            <!-- label -->
            <span class="fs-m no-wrap" [class.fw-bold]="item.value === selectedOption?.value">
              {{ item.label | translate }}
            </span>

            <!-- Coverage -->
            <small *ngIf="coverage" class="ms-2 text-end">
              <strong class="d-block">
                {{ item.rate.finalAmount | currency }} MXN
              </strong>
              <del *ngIf="item.rate.offerAmount" class="d-block gray fs-s">
                {{ item.rate.offerAmount | currency }} MXN
              </del>
            </small>
          </button>
      </li>
    </ul>
  </div>
</ng-container>
